
      var _path, _path2, _path3, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUploadUserList = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 45,
  height: 44,
  viewBox: "0 0 45 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.36 25.977c-2.475 0-4.723-1.355-5.76-3.47a5.645 5.645 0 0 1-.447-3.72 5.828 5.828 0 0 1 1.384-2.653 6.439 6.439 0 0 1 3.679-1.995 6.721 6.721 0 0 1 1.909-.055M14.36 25.979c-3.495-.003-8.78 2.859-9.735 7.154",
  stroke: "#E0C1FF",
  strokeWidth: 2.75,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.398 33.64a14.622 14.622 0 0 1 25.322 0",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 2.75,
  strokeLinecap: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.755 9.628a8.35 8.35 0 1 0 6.919 11.762",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 2.75,
  strokeLinecap: "round"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 34.875,
  y: 6.875,
  width: 2.75,
  height: 11,
  rx: 1.375,
  fill: "var(--theme-primary, #810ea9)"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 41.75,
  y: 11,
  width: 2.75,
  height: 11,
  rx: 1.375,
  transform: "rotate(90 41.75 11)",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"45\" height=\"44\" viewBox=\"0 0 45 44\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M14.3591 25.9774C11.8849 25.9771 9.6368 24.6225 8.60092 22.5078C8.01959 21.321 7.87963 20.0165 8.1527 18.7872C8.3662 17.8259 8.83223 16.9106 9.53721 16.1336C10.5024 15.0697 11.8096 14.3816 13.2158 14.1386C13.8398 14.0308 14.4832 14.0106 15.125 14.0842\" stroke=\"#E0C1FF\" stroke-width=\"2.75\" stroke-linecap=\"round\"/>\r\n<path d=\"M14.3594 25.9785C10.8645 25.9761 5.57977 28.8376 4.62518 33.1333\" stroke=\"#E0C1FF\" stroke-width=\"2.75\" stroke-linecap=\"round\"/>\r\n<path d=\"M14.3984 33.6394C17.011 29.1173 21.837 26.332 27.0595 26.332C32.282 26.3321 37.108 29.1175 39.7204 33.6396\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"2.75\" stroke-linecap=\"round\"/>\r\n<path d=\"M27.7546 9.62847C23.4553 9.27308 19.5932 12.2515 18.8444 16.4999C18.0955 20.7483 20.7064 24.8677 24.8681 26.0037C28.6806 27.0444 32.6443 25.2674 34.4463 21.8561C34.5266 21.7041 34.6025 21.5488 34.674 21.3904\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"2.75\" stroke-linecap=\"round\"/>\r\n<rect x=\"34.875\" y=\"6.875\" width=\"2.75\" height=\"11\" rx=\"1.375\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n<rect x=\"41.75\" y=\"11\" width=\"2.75\" height=\"11\" rx=\"1.375\" transform=\"rotate(90 41.75 11)\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/upload_user_list.7e2bdb7f9e3e25c0dd68bd46ea0a4d9b.svg"),
        {
          React: SvgUploadUserList,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      